import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { Personal } from "./Personal";
import { PersonalJerarquia } from "./PersonalJerarquia/PersonalJerarquia";

export const ACTAgregarPersonal: EntityClientAction = {
    name: 'ACTAgregarPersonal',
    label: 'Agregar Personal',
    title: <Text fw={700}>Agregar Personal</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    showActionInViewMode: true,
    views: ['perl_brwGestionPersonalDetalles'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {

        if (!modal) {
            console.warn('modal context not found');
            return Promise.resolve(false);
        }

        const parent = entity as Personal;

        await modal.open({
            modalProps: {
                title: <Text fw="700">Agregar Personal</Text>,
                size: 'xl'
            },
            focusOnClosed: element,
            content: <LookupFormAction
                lookupEntity={parent}
                viewName={parent.def.views.perl_brwGestionPersonalDetallesAgregar.name}
                title="Agregar personal"
                confirmContent="¿Está seguro de que desea agregar el personal seleccionado?"
                onActionFinished={async () => { if (onClose) await onClose(); }}
                modalFormSize="xl"
                enableView={true}
                onOK={
                    async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                        if (keys && keys.length > 0) {
                            const personaljerarquia = new PersonalJerarquia(parent.API.client, parent.parentKeys);
                            personaljerarquia.def.columns.c_superior_id.value = parent.parentKeys.c_superior_id as string;

                            await personaljerarquia.API.addData(abortSignal, keys, true);
                        }
                        return { Results: [{ Status: 0, Message: 'OK' }] } as DBStatusResult;
                    }
                }
            />

        });

        return false;
    }
}